
// src/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDsJGSa7qfQoxWUWNWSLYJwVXO3yUBWhAg",
  authDomain: "final-918a7.firebaseapp.com",
  projectId: "final-918a7",
  storageBucket: "final-918a7.firebasestorage.app",
  messagingSenderId: "493727754239",
  appId: "1:493727754239:web:0aabe593cf953c367d69ca",
  measurementId: "G-9F5HFM5SDR"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
